/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Transaction_Expired_TitleInputs */

const en_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Expired`)
};

const ar_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت صلاحية الطلب`)
};

const de_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung Abgelaufen`)
};

const es_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido caducado`)
};

const fr_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande expirée`)
};

const it_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordine scaduto`)
};

const ja_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご注文の有効期限が切れました`)
};

const ko_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 만료`)
};

const pt_br_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedido expirado`)
};

const ru_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок действия заказа истек`)
};

const th_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำสั่งซื้อหมดอายุ`)
};

const tr_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş Süresi Doldu`)
};

const zh_cn_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单过期`)
};

const zh_tw_dialog_transaction_expired_title = /** @type {(inputs: Dialog_Transaction_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂單過期`)
};

/**
* | output |
* | --- |
* | "Order Expired" |
*
* @param {Dialog_Transaction_Expired_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_transaction_expired_title = /** @type {((inputs?: Dialog_Transaction_Expired_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Transaction_Expired_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_transaction_expired_title(inputs)
	if (locale === "ar") return ar_dialog_transaction_expired_title(inputs)
	if (locale === "de") return de_dialog_transaction_expired_title(inputs)
	if (locale === "es") return es_dialog_transaction_expired_title(inputs)
	if (locale === "fr") return fr_dialog_transaction_expired_title(inputs)
	if (locale === "it") return it_dialog_transaction_expired_title(inputs)
	if (locale === "ja") return ja_dialog_transaction_expired_title(inputs)
	if (locale === "ko") return ko_dialog_transaction_expired_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_transaction_expired_title(inputs)
	if (locale === "ru") return ru_dialog_transaction_expired_title(inputs)
	if (locale === "th") return th_dialog_transaction_expired_title(inputs)
	if (locale === "tr") return tr_dialog_transaction_expired_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_transaction_expired_title(inputs)
	return zh_tw_dialog_transaction_expired_title(inputs)
});